import beneDetailsReducer from './beneDetailsReducer';
import { combineReducers } from "redux";

const allReducers = combineReducers({
    beneDetails: beneDetailsReducer,
});

export default allReducers;
